module.exports = __webpack_public_path__ + "static/media/url_to_widget1.b3d70bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/adminPanel/Content Management/assets/url_to_widget1.png
// module id = 1406
// module chunks = 1